import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IMessage,
  ICustomField,
  IGrid,
  IDialog,
  INavigation,
  IField,
  IDdlist,
} from "../../app/types";

export interface IMainContent {
  buttonList: IField[];
  caption: string;
  screen: string;
  messageList: IMessage[];
  fieldList: IField[];
  customFieldList: ICustomField[];
  gridList: IGrid[];
  navList: INavigation[];
  ddlist: IDdlist[];
  hiddenFields: IField[];
  headCheckboxList: Object;
  dialogPopUp: IDialog;
  nobuttons: [];
  showHeaders: boolean;
}

let initialState: IMainContent = {
  buttonList: [],
  caption: "",
  screen: "",
  messageList: [],
  fieldList: [],
  customFieldList: [],
  gridList: [],
  navList: [],
  ddlist: [],
  hiddenFields: [],
  headCheckboxList: {},
  dialogPopUp: {
    header: "",
    content: {
      title: "",
      url: "",
      details: {},
    },
    action: [],
  },
  nobuttons: [],
  showHeaders: true,
};

export const mainContentSlice = createSlice({
  name: "mainContent",
  initialState,
  reducers: {
    resetMainContentState: () => initialState,
    setMainContentButtonList(state, action: PayloadAction<IField[]>) {
      state.buttonList = action.payload;
    },
    setMainContentCaption(state, action: PayloadAction<string>) {
      state.caption = action.payload;
    },
    setMainContentScreen(state, action: PayloadAction<string>) {
      state.screen = action.payload;
    },
    setMainContentMessageList(state, action: PayloadAction<IMessage[]>) {
      state.messageList = action.payload;
    },
    setMainContentFieldList(state, action: PayloadAction<IField[]>) {
      state.fieldList = action.payload;
    },
    setMainContentCustomFieldList(
      state,
      action: PayloadAction<ICustomField[]>
    ) {
      state.customFieldList = action.payload;
    },
    setMainContentGridList(state, action: PayloadAction<IGrid[]>) {
      state.gridList = action.payload;
    },
    setMainContentNavList(state, action: PayloadAction<INavigation[]>) {
      state.navList = action.payload;
    },
    setMainContentDdlist(state, action: PayloadAction<IDdlist[]>) {
      state.ddlist = [...state.ddlist, ...action.payload];
    },
    setMainContentHiddenFields(state, action: PayloadAction<IField[]>) {
      state.hiddenFields = action.payload;
    },
    setMainContentHeadCheckboxList(state, action: PayloadAction<Object>) {
      state.headCheckboxList = action.payload;
    },
    setMainContentDialogPopUp(state, action: PayloadAction<IDialog>) {
      state.dialogPopUp = action.payload;
    },
    setMainContentNoButtons(state, action: PayloadAction<[]>) {
      state.nobuttons = action.payload;
    },
    setMainContentShowHeaders(state, action: PayloadAction<boolean>) {
      state.showHeaders = action.payload;
    },
  },
});

export const {
  resetMainContentState,
  setMainContentButtonList,
  setMainContentCaption,
  setMainContentScreen,
  setMainContentMessageList,
  setMainContentFieldList,
  setMainContentCustomFieldList,
  setMainContentGridList,
  setMainContentNavList,
  setMainContentDdlist,
  setMainContentHiddenFields,
  setMainContentHeadCheckboxList,
  setMainContentDialogPopUp,
  setMainContentNoButtons,
  setMainContentShowHeaders,
} = mainContentSlice.actions;

export default mainContentSlice.reducer;
